import { t } from 'ttag';

// This widget has no backend record, hence the sentinel id. Kept out of
// WIDGET_ENTITY_TYPE, which drives the Add Widget menu and the type filter.
export const REG_FORM_WIDGET_ID = 'reg-form';
export const REG_FORM_WIDGET_TYPE = 'registration';

// The row the list API can't give us.
export const getRegFormWidgetRow = () => ({
  id: REG_FORM_WIDGET_ID,
  name: t`Registration Form`,
  contentEntityType: REG_FORM_WIDGET_TYPE,
});

// The iframe the customer pastes. `data-eventmobi-content-view-widget` is what the
// resize listener below matches on, so it isn't optional.
const getWidgetIframe = src =>
  `<iframe
  data-eventmobi-content-view-widget
  src="${src}"
  width="100%"
  height="100%"
  style="border:0"
  loading="lazy"
></iframe>`;

// Listens for the resize message the widget posts from inside the iframe and sizes
// the iframe to match. Without it the iframe stays at whatever height is set above.
const getResizeListener = origin =>
  `<script>
(function () {
  window.addEventListener('message', function (event) {
    if (event.origin !== '${origin}') return;
    var data = event.data;
    if (!data || data.type !== 'eventmobi:content-view-widget:resize') return;
    if (typeof data.height !== 'number') return;
    var iframes = document.querySelectorAll('iframe[data-eventmobi-content-view-widget]');
    for (var i = 0; i < iframes.length; i++) {
      if (iframes[i].contentWindow === event.source) {
        iframes[i].style.height = data.height + 'px';
        break;
      }
    }
  });
})();
</script>`;

export const getEmbedCodes = (websiteBasePath, eventCode, widgetId) => {
  const iframe = getWidgetIframe(
    `https://${websiteBasePath}/_widgets/${eventCode}/${widgetId}?embed=true`,
  );
  const { origin } = new URL(`https://${websiteBasePath}`);

  return { iframe, script: `${iframe} ${getResizeListener(origin)}` };
};
